import React from 'react';
import { Sparkles } from 'lucide-react';

const ProductsSection = () => {
  const products = [
    'https://images.unsplash.com/photo-1598528738936-c50861cc75a9',
    'https://images.unsplash.com/photo-1596462502278-27bfdc403348',
    'https://images.unsplash.com/photo-1512496015851-a90fb38ba796',
    'https://images.unsplash.com/photo-1542452255191-c85a98f2c5d1',
    'https://images.unsplash.com/photo-1511923199659-1c16881689de',
    'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937'
  ];

  const brands = [
    'Makeup Forever',
    'Fenty Beauty',
    'NARS',
    'Estée Lauder',
    'Dior',
    'MAC Cosmetics',
    'Urban Decay',
    'Huda Beauty'
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <Sparkles className="w-12 h-12 text-rose-500 mx-auto mb-4" />
          <p className="text-rose-500 text-sm font-medium tracking-wider uppercase mb-2">Premium Quality</p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-stone-800 mb-4">Products Used By Khushi</h2>
          <p className="text-stone-600 max-w-2xl mx-auto">
            I exclusively use premium international brands to ensure the highest quality and longest-lasting results
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 max-w-6xl mx-auto mb-16">
          {products.map((product, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-xl aspect-square bg-rose-50 hover:shadow-xl transition-all duration-300"
            >
              <img
                src={product}
                alt={`Premium Makeup Product ${index + 1}`}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-rose-50 to-pink-50 rounded-2xl p-8 max-w-4xl mx-auto border border-rose-200">
          <h3 className="text-2xl font-semibold text-stone-800 mb-6 text-center">Premium Brands We Use</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {brands.map((brand, index) => (
              <div
                key={index}
                className="bg-white rounded-lg p-4 text-center shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <p className="text-stone-700 font-medium text-sm">{brand}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;